var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgContactsNavigationActive = function SvgContactsNavigationActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8L4.5 8",
    stroke: "#FF4473",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12L4.5 12",
    stroke: "#FF4473",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16L4.5 16",
    stroke: "#FF4473",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H20C21.1046 1 22 1.89543 22 3V21C22 22.1046 21.1046 23 20 23H5C3.89543 23 3 22.1046 3 21V3ZM10.5 10C10.5 8.89543 11.3954 8 12.5 8C13.6046 8 14.5 8.89543 14.5 10C14.5 11.1046 13.6046 12 12.5 12C11.3954 12 10.5 11.1046 10.5 10ZM15.4055 12.7492C16.0839 12.0324 16.5 11.0648 16.5 10C16.5 7.79086 14.7091 6 12.5 6C10.2909 6 8.5 7.79086 8.5 10C8.5 11.0648 8.91606 12.0324 9.59447 12.7492C7.7491 13.7725 6.5 15.7404 6.5 18H8.5C8.5 15.7909 10.2909 14 12.5 14C14.7091 14 16.5 15.7909 16.5 18H18.5C18.5 15.7404 17.2509 13.7725 15.4055 12.7492Z",
    fill: "#FF4473"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 19,
    height: 22,
    rx: 2,
    stroke: "#FF4473",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContactsNavigationActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contacts-navigation-active.be1ff373ef23a8dad1e97cc05901b52f.svg";